const DracoParamSalesRequest = {    
    pageDesc: `- 제품 정보의 조회,등록,수정,삭제 등의 관리를 할 수 있는 화면 입니다.
- 제품은 'RTU' 제품과 기타 제품을 등록 관리 할 수 있습니다.
- 제품은 일련번호, 제품구분, 제품명의 속성이 관리 됩니다.`,

    fewShot: `요청내용: 제품구분이 기타이고 제품명이 SVR 인 제품을 검색 해줘.

응답내용: 
{  
  "command":[
    {"cd":"SC", "id":"prdtDivCd", "val":"002", "custom":"S"},
    {"cd":"IW", "id":"prdtNm", "val":"SVR", "custom":"S"},
    {"cd":"BC", "id":"search", "custom":"S"}
  ]  
}

요청내용: 전체 제품을 검색해줘.

응답내용: 
{  
  "command":[
    {"cd":"SC", "id":"prdtDivCd", "val":"", "custom":"S"},
    {"cd":"IW", "id":"prdtNm", "val":"", "custom":"S"},
    {"cd":"BC", "id":"search", "custom":"S"}
  ]  
}

요청내용: 사용여부는 사용을 선택 해줘

응답내용: 
{  
  "command":[
    {"cd":"SC", "id":"uesYn", "val":"Y", "custom":"F"}  
  ]  
}
`,

    tags:[
    {
        name: "제품구분",
        type: "Select",
        id: "prdtDivCd",
        items: `Value:, 제품구분명:전체
Value:001, 제품구분명:eTU
Value:002, 제품구분명:기타`,
        getItemsVector: "N",
        custom:"S",
        desc:`검색 필터에 사용되는 제품구분 항목 입니다.`            
    },
    {
        name: "제품명",
        type: "Input", 
        id: "prdtNm",
        items: "",
        getItemsVector: "N",
        custom:"S",
        desc:"검색 필터에 사용되는 제품명 항목 입니다."
    },

    {
        name: "등록 제품구분",
        type: "Select",
        id: "prdtDivCd",
        items: `Value:, 제품구분명:전체
Value:001, 제품구분명:eTU
Value:002, 제품구분명:기타`,
        getItemsVector: "N",
        custom:"F",
        desc:`등록 팝업에 사용되는 제품구분 항목 입니다.`            
    },
    {
        name: "등록 제품명",
        type: "Input", 
        id: "prdtNm",
        items: "",
        getItemsVector: "N",
        custom:"F",
        desc:"등록 팝업에 사용되는 제품명 항목 입니다."
    },
    {
        name: "사용여부",
        type: "Select", 
        id: "useYn",
        items: `Value:Y, 명칭:사용
Value:N, 명칭:미사용`,
        getItemsVector: "N",
        custom:"F",
        desc:"등록 팝업에 사용되는 사용여부 항목 입니다."
    },
    {
        name: "비고",
        type: "Input", 
        id: "rmrk",
        items: "",
        getItemsVector: "N",
        custom:"F",
        desc:"등록 팝업에 사용되는 비고 항목 입니다."
    },

    {
        name: "조회 버튼",
        type: "Button", 
        id: "search",
        items: "",
        getItemsVector: "N",
        custom:"S",
        desc:"제품 정보를 검색 할때 클릭 하는 버튼 입니다."
    },
    {
        name: "등록 버튼",
        type: "Button", 
        id: "add",
        items: "",
        getItemsVector: "N",
        custom:"S",
        desc:"제품 정보를 신규 등록 할때 클릭 하는 버튼 입니다."
    },
    {
        name: "저장 버튼",
        type: "Button", 
        id: "save",
        items: "",
        getItemsVector: "N",
        custom:"S",
        desc:"제품 정보를 저장 할때 클릭 하는 버튼 입니다."
    },
    {
        name: "닫기 버튼",
        type: "Button", 
        id: "close",
        items: "",
        getItemsVector: "N",
        custom:"S",
        desc:"제품 정보 팝업을 종료 할때 클릭 하는 버튼 입니다."
    }]
}


export default DracoParamSalesRequest;